/** @file helpMenu: Help: Guides, Keyboard shortcuts, About. */
import type { MenuBuilder } from './menuTypes';

/** Help rows; each opens a dialog of the shell layer. Guides need a server. */
export const helpMenu: MenuBuilder = (ctx) => {
  const open = (dialog: 'guides' | 'shortcuts' | 'about') => (): void => { ctx.store.getState().setShell({ dialog }); };
  return [
    { kind: 'item', id: 'help.guides', label: 'Guides', disabled: ctx.api === null, onSelect: open('guides') },
    { kind: 'item', id: 'help.shortcuts', label: 'Keyboard shortcuts', onSelect: open('shortcuts') },
    { kind: 'separator' },
    { kind: 'item', id: 'help.about', label: 'About Pose3D', onSelect: open('about') },
  ];
};
